import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { AvatarService } from '@core/avatar.service';
import { ApiResponse } from '@models/api-response';
import { Avatar } from '@models/avatar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GradeType } from '../enums/grade-type';
import { ProductType } from '../enums/product-type';

@Component({
  selector: 'zbp-student-avatar-modal',
  templateUrl: './student-avatar-modal.component.html',
  styleUrls: ['./student-avatar-modal.component.scss'],
  standalone: false
})
export class StudentAvatarModalComponent implements OnInit {
  form: FormGroup;
  cancelButtonClicked: boolean = false;

  @Input() avatar: Avatar;
  @Input() productType: ProductType;
  @Input() gradeType: GradeType;

  constructor(private activeModal: NgbActiveModal, private avatarService: AvatarService) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl(this.avatar.name, this.getRequiredValidator('name')),
      color: new FormControl(this.avatar.color, this.getRequiredValidator('color')),
    });
  }

  save() {
    if (!this.cancelButtonClicked && this.form.valid) {
      const { name, color } = this.form.value;
      this.avatarService.saveAvatar(name, color, this.productType, this.gradeType)
        .subscribe((res: ApiResponse<Avatar>) => {
          if (res.success) {
            this.activeModal.close(res.response);
          } else {
            this.activeModal.dismiss(res.messages);
          }
        }, (err) => {
          console.error(err);
          this.activeModal.dismiss(['An error occurred saving your avatar.']);
        });
    }
  }

  cancel() {
    this.cancelButtonClicked = true;
    this.activeModal.dismiss([]);
  }

  private getRequiredValidator(formItem: string): ValidatorFn {
    if (formItem === 'name') {
      const pattern = /^[a-z0-9A-Z ][a-z0-9A-Z ]+$/;
      return (control?: FormControl): ValidationErrors => (
        control?.value && !pattern.test(control.value)
          ? { invalidAvatarName: 'Special characters are not allowed in your blob\'s name.' }
          : null
      );
    }

    return (control: FormControl): ValidationErrors => (
      !control.value ? { emptyText: 'You must select' } : null
    );
  }
}
